<div
  mat-dialog-title
  class="d-flex justify-content-between align-items-center pt-2"
>
  <div class="prese_heading">
    <h2 class="m-0">Public post settings</h2>
  </div>
  <div class="prese_button">
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
<mat-dialog-content style="padding-bottom: 0px; margin-bottom: 10px">
  <div class="pres_heading">
    <div class="manj_sectiom">
      <div class="shop_service_sec">
        <h4>Allow customer/member post</h4>
      </div>
      <div class="srd_fft">
        <mat-slide-toggle
          [checked]="toShowCheck === 1"
          (change)="onToggleChange($event)"
        ></mat-slide-toggle>
      </div>
    </div>

    <p class="set_heading">
      Your customers and members can post updates into your business's own social network. This include pictures and videos too. Though It's only available within your supervision and business network, you can restrict it too.
    </p>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end" style="margin-bottom: 0px; padding-bottom: 0px">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-flat-button color="accent" (click)="onSave()">Save</button>
</mat-dialog-actions>
